import { GuestListsState } from './guest-lists.types'

export default (): GuestListsState => ({
  data: {},
  filters: {}
})
